export default __webpack_public_path__ + "static/media/vid_play.4a9bfe31.svg";